module.exports = __webpack_public_path__ + "static/media/Allan Benson - 1920.459d71c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Allan Benson - 1920.jpg
// module id = 435
// module chunks = 0